export function nullableBoolCellRenderer(params) {
	let valueCleaned = booleanCleaner(params.value);
	if (valueCleaned === true) {
		return "<span title='true' class='ag-icon ag-icon-tick content-icon'></span>";
	} else if (valueCleaned === false) {
		return "<span title='false' class='ag-icon ag-icon-cross content-icon'></span>";
	} else if (params.value === null || params.value === "undefined") {
		return "<span title='null' class='ag-icon ag-icon-unlinked content-icon'></span>";
	} else {
		return 'error';
	}
}

window.nullableBoolCellRenderer = nullableBoolCellRenderer

export function booleanCellRenderer(params) {
	let valueCleaned = booleanCleaner(params.value);
	if (valueCleaned === true) {
		return "<span title='true' class='ag-icon ag-icon-tick content-icon'></span>";
	} else if (valueCleaned === false) {
		return "<span title='false' class='ag-icon ag-icon-cross content-icon'></span>";
	} else if (params.value !== null && params.value !== undefined) {
		return params.value.toString();
	} else {
		return null;
	}
}

window.booleanCellRenderer = booleanCellRenderer

export function booleanFilterCellRenderer(params) {
	let valueCleaned = booleanCleaner(params.value);
	if (valueCleaned === true) {
		return "<span title='true' class='ag-icon ag-icon-tick content-icon'></span>";
	} else if (valueCleaned === false) {
		return "<span title='false' class='ag-icon ag-icon-cross content-icon'></span>";
	} else if (params.value === null || params.value === "undefined") {
		return "<span title='null' class='ag-icon ag-icon-unlinked content-icon'></span>";
	} else {
		return "(empty)";
	}
}

window.booleanFilterCellRenderer = booleanFilterCellRenderer

export function booleanCleaner(value) {
	if (value === "true" || value === true || value === 1 || value === "yes") {
		return true;
	} else if (value === "false" || value === false || value === 0 || value === "no") {
		return false;
	} else {
		return null;
	}
}

window.booleanCleaner = booleanCleaner

export function booleanComparator(value1, value2) {
	let value1Cleaned = booleanCleaner(value1);
	let value2Cleaned = booleanCleaner(value2);
	let value1Ordinal = value1Cleaned === true ? 0 : (value1Cleaned === false ? 1 : 2);
	let value2Ordinal = value2Cleaned === true ? 0 : (value2Cleaned === false ? 1 : 2);
	return value1Ordinal - value2Ordinal;
}

window.booleanComparator = booleanComparator
